import styles from "./styles.module.scss";

export const BgLinear = () => {
  return (
    <div className={styles.frame}>
      <div className={`${styles.bg} ${styles.bg_1}`} />
      <div className={`${styles.bg} ${styles.bg_2}`} />
    </div>
  );
};
